import React from 'react'
import { LoadingAnimation } from 'src/admin/components/Loader'
import { AuthConsumer } from '../AuthProvider'

const SilentRenew = () => (
  <AuthConsumer>
    {({ signinSilentCallback }) => {
      signinSilentCallback()
      return <LoadingAnimation />
    }}
  </AuthConsumer>
)

export default SilentRenew
